import { FunctionComponent, useEffect, useState } from 'react';
import {
  EngagePostMessageActions,
  ImagesService,
  SendMessageToSelf,
  useIframeEngageActionListener,
} from '../services';
import { MenuItem } from '@mui/material';
import { OptionsMenu } from './save-options.styles';
import db from 'mime-db';

interface SaveOptionsProps {
  accessToken: string;
  api1Origin: string;
  engageOrigin: string;
  jobsEnabled: boolean;
}

export const SaveOptions: FunctionComponent<SaveOptionsProps> = ({
  engageOrigin,
  jobsEnabled,
  accessToken,
  api1Origin,
}) => {
  const eventBody = useIframeEngageActionListener({
    engageOrigin,
    action: EngagePostMessageActions.SAVE_OPTIONS_POPUP,
  });
  const [open, setOpen] = useState(false);
  const [contactId, setContactId] = useState('');
  const [photoUrl, setPhotoUrl] = useState('');
  const [targetPosition, setTargetPosition] = useState<null | {
    left: number;
    top: number;
  }>(null);

  const chooseOption = (type: string) => {
    SendMessageToSelf(
      {
        REQUEST_ACTION: {
          type,
          associationId: contactId,
          associationType: 'contact',
          photoUrl,
        },
      },
      true
    );
    handleClose();
  };

  const openSaveAsDialog = async () => {
    const imagesService = new ImagesService(
      engageOrigin,
      api1Origin,
      accessToken
    );
    const blob = await imagesService.getTwilioPhotoContents(photoUrl);
    const extensions = db[blob.type].extensions ?? [];
    const extension = extensions.length ? extensions[0] : null;

    if (!blob || !extension) {
      return;
    }

    const fileHandle = await (self as any).showSaveFilePicker({
      suggestedName: `Engage.${extension}`,
      startIn: 'downloads',
    });

    const fileStream = await fileHandle.createWritable();

    await fileStream.write(blob);
    await fileStream.close();
  };

  useEffect(() => {
    setOpen(eventBody != null);

    if (eventBody) {
      setContactId(eventBody.contactId);
      setPhotoUrl(eventBody.photoUrl);
      setTargetPosition(eventBody.targetPosition);
    }
  }, [eventBody]);

  const handleClose = () => {
    setOpen(false);
    setContactId('');
    setPhotoUrl('');
  };

  function SaveToJobMenuItem() {
    if (jobsEnabled) {
      return (
        <MenuItem
          data-e2e="save-photo-to-job"
          onClick={() =>
            chooseOption(EngagePostMessageActions.OPEN_SAVE_TO_JOB_MODAL)
          }
        >
          Save to job
        </MenuItem>
      );
    }

    return null;
  }

  return (
    <div>
      <OptionsMenu
        id="save-options-menu"
        data-e2e="save-options-menu"
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={targetPosition}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        PaperProps={{ sx: { width: '288px' } }}
      >
        <MenuItem
          data-e2e="save-photo-to-contact"
          onClick={() =>
            chooseOption(EngagePostMessageActions.OPEN_SAVE_TO_CONTACT_MODAL)
          }
        >
          Save photo to contact
        </MenuItem>
        <SaveToJobMenuItem></SaveToJobMenuItem>
        <MenuItem data-e2e="save-photo-to-computer" onClick={openSaveAsDialog}>
          Save photo to computer
        </MenuItem>
      </OptionsMenu>
    </div>
  );
};
